export function DragVerticalFill({
  color = 'currentColor',
  size = 24,
  strokeWidth = 2,
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      aria-hidden={otherProps['aria-label'] ? undefined : 'true'}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      />
    </svg>
  )
}
